// 1. Tenant ID: em {tenant}.oporteiro.app vem do endereço (o mesmo build serve todos os condomínios);
// em localhost e homologação, de VITE_TENANT_ID.
export const DOMINIO_BASE = (import.meta.env.VITE_DOMINIO_BASE || 'oporteiro.app').toLowerCase();

export function resolverTenant(hostname, fallback) {
  const host = String(hostname || '').toLowerCase();
  const sufixo = `.${DOMINIO_BASE}`;
  if (host.endsWith(sufixo)) {
    const rotulo = host.slice(0, -sufixo.length);
    if (/^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/.test(rotulo)) return rotulo;
  }
  return fallback;
}

export const TENANT_ID = resolverTenant(
  typeof window !== 'undefined' ? window.location.hostname : '',
  import.meta.env.VITE_TENANT_ID,
);

// 2. Acessa as URLs das APIs
export const API_CONDOMINIO_BASE_URL = import.meta.env.VITE_API_CONDOMINIO_BASE_URL;
export const API_ENCOMENDA_BASE_URL = import.meta.env.VITE_API_ENCOMENDA_BASE_URL;

export const SKIP_AUTH = import.meta.env.VITE_SKIP_AUTH === 'true';
export const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN;
export const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID;
export const AUTH0_AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE;

// Configuração de Logs
export const LOG_LEVEL = import.meta.env.VITE_LOG_LEVEL || (import.meta.env.DEV ? 'debug' : 'error');
export const LOG_API_URL = import.meta.env.VITE_LOG_API_URL || null;
export const APPINSIGHTS_KEY = import.meta.env.VITE_APPINSIGHTS_KEY || null;
export const DATADOG_CLIENT_TOKEN = import.meta.env.VITE_DATADOG_CLIENT_TOKEN || null;

// Habilita logs detalhados de cada chamada ao backend (entrada e saída).
// Default: ativo em desenvolvimento, inativo em produção.
// Sobrescreva com VITE_API_LOG_ENABLED=true|false no .env.
export const API_LOG_ENABLED = (() => {
  const val = import.meta.env.VITE_API_LOG_ENABLED;
  if (val !== undefined) return val === 'true';
  return import.meta.env.DEV === true;
})();

export const MOCK_USER = {
  name: "Usuário Dev",
  email: "dev@oporteiro.app",
  picture: "https://i.pravatar.cc/150?u=dev", // Uma imagem de avatar genérica
};

// 3. Acessa o Título da Aplicação
//export const APP_TITLE = import.meta.env.VITE_APP_TITLE || "O Porteiro";
export const APP_TITLE = "O Porteiro";

// Validação: Garante que o Tenant ID foi definido no arquivo .env
if (!TENANT_ID) {
  throw new Error(`Condomínio não identificado: acesse por {condominio}.${DOMINIO_BASE} ou defina VITE_TENANT_ID no .env.`);
}

if (!API_CONDOMINIO_BASE_URL) {
  throw new Error("A variável de ambiente VITE_API_CONDOMINIO_BASE_URL não está definida. Verifique seu arquivo .env.");
}

if (!API_ENCOMENDA_BASE_URL) {
  throw new Error("A variável de ambiente VITE_API_ENCOMENDA_BASE_URL não está definida. Verifique seu arquivo .env.");
}

// --- FEATURE FLAGS ---

// Valores padrão; o cadastro do condomínio (src/lib/tenant.js) os atualiza antes da primeira
// renderização. Uma VITE_FEATURE_* definida no .env prevalece sobre o cadastro (override local).
const FLAGS = {
  ENCOMENDAS: ['VITE_FEATURE_ENCOMENDAS_ENABLED', true],
  // false por padrão: sem o cadastro (falha de rede), não liga a autorização de acesso em nenhum condomínio.
  AUTORIZACAO_ACESSO: ['VITE_FEATURE_AUTORIZACAO_ACESSO_ENABLED', false],
  WHATSAPP: ['VITE_FEATURE_WHATSAPP_ENABLED', false],
  BLACKLIST: ['VITE_FEATURE_BLACKLIST_ENABLED', false],
  WHATSAPP_CONCILIACAO: ['VITE_FEATURE_WHATSAPP_CONCILIACAO_ENABLED', false],
};

export const FEATURE_OVERRIDES = Object.fromEntries(
  Object.entries(FLAGS)
    .filter(([, [env]]) => import.meta.env[env] !== undefined)
    .map(([flag, [env]]) => [flag, import.meta.env[env] === 'true']),
);

export const FEATURES = Object.fromEntries(
  Object.entries(FLAGS).map(([flag, [, padrao]]) => [flag, FEATURE_OVERRIDES[flag] ?? padrao]),
);
